"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var _ListRow = require("./ListRow.utils");

var _lists = require("../../../Action/utils/lists");

var _utils = require("../../../ActionModals/utils");

var _HelpCallout = require("../HelpCallout/HelpCallout");

var _EstimatedSavingsPopover = require("./components/EstimatedSavingsPopover");

var _formatDollarValue = require("./utils/formatDollarValue");

var _locale = require("../../../../context/locale");

var _dates = require("../../../../utils/dates");

var _currency = require("../../../../utils/currency");

/* eslint-disable @typescript-eslint/strict-boolean-expressions */
const StyledCell = (0, _styledComponents.default)(_blocks.DataGridCell)`
  height: unset;
  min-height: 56px;
  max-height: calc(16px * 12);
  flex-grow: 1;
`;
const EstimatedSavingsCell = (0, _styledComponents.default)(StyledCell)`
  overflow: visible;
  justify-content: flex-end;
`;
const SummaryCell = (0, _styledComponents.default)(StyledCell)`
  // set max number of lines based on line-height
  overflow-x: hidden;
  overflow-y: auto;
  align-items: flex-start;

  ${_blocks.Main} {
    white-space: normal;
    padding: 8px 0;
  }
`;
const Capitalise = (0, _styledComponents.default)(_blocks.Main)`
  text-transform: capitalize;
  line-height: 0;
`;
const SavingsValue = (0, _styledComponents.default)(_blocks.Main)`
  position: relative;
  overflow: visible !important;

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    border: 1px dashed ${_blocks.color.theme.typography.ink};
  }
`;

const ListRow = ({
  id,
  summary,
  context,
  priority,
  status,
  updatedAt,
  responsible,
  siteName,
  projectName,
  projectKey,
  assignee,
  onClick,
  isActive,
  savings
}) => {
  var _savings$totalImpact, _savings$operational;

  const currencySymbol = (0, _currency.useCurrencySymbol)(projectKey);
  const {
    locale
  } = (0, _locale.useLocale)();
  const savingsTotal = (0, _formatDollarValue.formatDollarValue)(((_savings$totalImpact = savings === null || savings === void 0 ? void 0 : savings.totalImpact) !== null && _savings$totalImpact !== void 0 ? _savings$totalImpact : 0) + ((_savings$operational = savings === null || savings === void 0 ? void 0 : savings.operational) !== null && _savings$operational !== void 0 ? _savings$operational : 0));
  return /*#__PURE__*/React.createElement(_blocks.DataGridRow, {
    selected: isActive,
    cursor: "pointer",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(StyledCell, null, /*#__PURE__*/React.createElement(_blocks.Main, null, `#${(0, _ListRow.parseId)(id)}`)), /*#__PURE__*/React.createElement(StyledCell, null, /*#__PURE__*/React.createElement(_blocks.Main, null, (0, _dates.localizedFormatDistanceToNowStrict)(new Date(updatedAt), locale))), /*#__PURE__*/React.createElement(StyledCell, null, /*#__PURE__*/React.createElement(Capitalise, null, status && /*#__PURE__*/React.createElement(_blocks.Chip, {
    size: "thin",
    type: "priority",
    appearance: "solid",
    priority: _utils.statusMap[status]
  }, (0, _lists.getStatusMap)(_core.i18n)[status]) || '–')), /*#__PURE__*/React.createElement(StyledCell, null, /*#__PURE__*/React.createElement(_blocks.Main, {
    title: `${siteName}, ${projectName}`
  }, siteName), /*#__PURE__*/React.createElement(_blocks.Supportive, null, projectName)), /*#__PURE__*/React.createElement(SummaryCell, null, /*#__PURE__*/React.createElement(_blocks.Main, {
    title: summary
  }, summary)), /*#__PURE__*/React.createElement(StyledCell, null, /*#__PURE__*/React.createElement(Capitalise, null, /*#__PURE__*/React.createElement(_blocks.Chip, {
    size: "thin",
    type: "priority",
    appearance: "accent",
    priority: _utils.priorityMap[priority]
  }, (0, _lists.getPriorityMap)(_core.i18n)[priority]))), /*#__PURE__*/React.createElement(StyledCell, null, /*#__PURE__*/React.createElement(_blocks.Main, null, context && (0, _lists.getContextMap)(_core.i18n)[context] || '–')), /*#__PURE__*/React.createElement(StyledCell, null, /*#__PURE__*/React.createElement(_blocks.Main, {
    title: responsible && (0, _lists.getResponsibleMap)(_core.i18n, projectKey === 'WOOL')[responsible] || '-'
  }, responsible && (0, _lists.getResponsibleMap)(_core.i18n, projectKey === 'WOOL')[responsible] || '-'), /*#__PURE__*/React.createElement(_blocks.Supportive, null, assignee)), /*#__PURE__*/React.createElement(EstimatedSavingsCell, null, savingsTotal !== '0' && /*#__PURE__*/React.createElement(_HelpCallout.HelpCallout, {
    id: `${id}-total-savings-help-trigger`,
    renderTrigger: /*#__PURE__*/React.createElement(SavingsValue, null, currencySymbol, savingsTotal)
  }, /*#__PURE__*/React.createElement(_EstimatedSavingsPopover.PopoverContent, {
    savings: savings,
    projectKey: projectKey
  }))));
};

var _default = /*#__PURE__*/React.memo(ListRow, (p, n) => p.isActive === n.isActive && p.updatedAt === n.updatedAt && p.status === n.status && p.responsible === n.responsible && p.context === n.context && p.priority === n.priority);

exports.default = _default;
module.exports = exports.default;